module.exports = __webpack_public_path__ + "img/111.45387d3.jpg";